export default __webpack_public_path__ + "static/media/Sun Life Logo2.87fba77f.png";